module.exports = __webpack_public_path__ + "assets/html.a14ff335.svg";